import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { normalizeApiFeedback } from '../../../util/apiFeedback';
import ErrorHandler from '../../loader/ErrorHandler';
import UnexpectedError from '../../loader/UnexpectedError';

const FALLBACK_MODE = {
  DEFAULT: 'default',
  LOCAL_ONLY: 'local-only',
};

const LocalApiErrors = ({ className, error, fallbackMode, requestId }) => {
  if (!error) {
    return null;
  }

  const { fallbackError, localMessages } = normalizeApiFeedback(error);

  if (localMessages.length > 0) {
    return (
      <Alert className={className} color="danger" key={requestId}>
        {localMessages.map((message) => (
          <div key={message}>{message}</div>
        ))}
      </Alert>
    );
  }

  if (fallbackMode === FALLBACK_MODE.LOCAL_ONLY) {
    return null;
  }

  if (fallbackError.publicMessage || fallbackError.httpStatusCode === 404) {
    return <ErrorHandler error={fallbackError} />;
  }

  return <UnexpectedError />;
};

LocalApiErrors.propTypes = {
  className: PropTypes.string,
  error: PropTypes.any,
  fallbackMode: PropTypes.oneOf(Object.values(FALLBACK_MODE)),
  requestId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

LocalApiErrors.defaultProps = {
  className: undefined,
  error: null,
  fallbackMode: FALLBACK_MODE.DEFAULT,
  requestId: undefined,
};

export default LocalApiErrors;
export { FALLBACK_MODE as LocalApiErrorsFallbackMode };
